import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Spinner from './Spinner';

const MailItem = ({ match }) => {

const [loading, setLoading] = useState(true);
const [unread, setUnread] = useState(false);
const [mess, setMess] = useState({});
const [sponimg, setSponimg] = useState({});
const [isClassic, setIsClassic] = useState(false);
const [isInstant, setIsInstant] = useState(false);
const [gwayid, setGwayId] = useState([]);

const fetchMessage = async () => {
    const fetchItem = await fetch(`${process.env.REACT_APP_API_URL}/b/fullmessage/${ match.params.messageid }`, { headers: { 'x-access-token': localStorage.getItem('x-access-token')} });
    const item = await fetchItem.json();
    const content = item[0];
    setMess(content);
    setLoading(false);
    const img = await fetch(`${process.env.REACT_APP_API_URL}/b/sponimg/${content.senderid}`);
    const newImg = await img.json();
    setSponimg(newImg);
    if (content.unread === true) {
        const respond = await fetch(`${process.env.REACT_APP_API_URL}/b/markasread/${ match.params.messageid }`, { headers: { 'x-access-token': localStorage.getItem('x-access-token')} });
        setUnread(false);
    } else return;
};

useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

useEffect(() => {
   fetchMessage();
  }, [])

useEffect(() => {
    if (mess.classicgway === true) {
        setGwayId(mess.gwayid)
        return setIsClassic(true);
    } if (mess.instantwingway === true) {
        setGwayId(mess.gwayid)
        return setIsInstant(true);
    }
}, [mess])

return (
    <div>
            <br />
            <br />
            <br />
            {
        (loading) ? ( <Spinner /> ) : (
            <div className="glass-account-edit">
                <h1>✉️ Message from</h1>
                <Link to={`/business/${mess.senderid}`}><img id="image" src={`${process.env.REACT_APP_CDN_URL}/${sponimg.image}`} alt="" height="100" width="100" /></Link><h1><Link to={`/business/${mess.senderid}`}>{mess.name}</Link>:</h1>
                <div className="glass-giveaway-details">
                <h2>{mess.message}</h2>
                <p><small>Received at {new Date(mess.created_at).toUTCString()}</small></p>
                </div>
                <br />
                {isClassic === true ? (<h3><Link target="_blank" to={`/giveaways/${gwayid}`}>View Giveaway</Link></h3>) : isInstant === true ? (<h3><Link target="_blank" to={`/instant/${gwayid}`}>View Giveaway</Link></h3>) : ''}
                <div className="giveaway-button">
                <h3><Link to={`/reply/${mess.messageid}`}>Reply</Link></h3>
                </div>
                <br />
                <p><Link to={`/mailbox`}>Back to Mailbox</Link></p>
      <br />
      </div>)
}
            <br />
            <br />
            <br />
            <br />
    </div>
)

}

export default MailItem;